import './styles.scss';
import { FormattedMessage } from 'react-intl';

import { Button } from '../Button';
import { SubsectionMenu } from 'components/SubsectionMenu';
import { Uploader } from 'components/Uploader/Uploader';
import { useIsMobile } from 'hooks/useIsMobile';

export interface StockCardProps {
  downloadTemplate: () => void;
  onChange: (id: StockCardProps['idSelected']) => void;
  idSelected: typeof OPTIONS[number]['id'];
}

const OPTIONS = [
  {
    label: 'Zone',
    id: 'zone' as const,
  },
  {
    label: 'Tutta Italia',
    id: 'italia' as const,
  },
];

export const StockCard = ({ idSelected, onChange, downloadTemplate }: StockCardProps): JSX.Element => {
  const isMobile = useIsMobile();
  return (
    <div className="stockCard__container">
      <div className="stockCard__menu">
        <p>Calcola prezzo per:</p>
        <SubsectionMenu
          options={OPTIONS}
          idSelected={idSelected}
          onChange={onChange as unknown as (id: string) => void}
        />
      </div>
      {!isMobile && (
        <div>
          <Button onClick={downloadTemplate} big secondaryOutline>
            <FormattedMessage id="download-stock-template" />
          </Button>
          <Uploader />
        </div>
      )}
    </div>
  );
};
